<template>
  <div class="mx-auto w-full max-w-sm">
    <div>
      <img class="h-16 w-auto" src="../../assets/logo.svg" alt="Lider logo"/>
      <h2 class="mt-6 text-3xl leading-9 font-extrabold text-gray-900">
        Создайте новый кабинет координатора
      </h2>
      <p class="mt-2 text-sm leading-5 text-gray-600 max-w">
        Или
        <router-link to="/login" class="link">войдите в свой аккаунт</router-link>
      </p>
    </div>

    <div class="mt-8">
      <div class="mt-6">
        <form action="#" @submit.prevent.stop="tryReg">
          <ui-form-item id="email" error-text="text" required label="Электронная почта">
            <ui-form-text v-model="form.email"/>
          </ui-form-item>
          <ui-form-item id="email" error-text="text" required label="Пароль для входа" class="mt-4">
            <ui-form-password :show="true" v-model="form.password"/>
          </ui-form-item>


          <div class="mt-4 flex justify-start">
            <ui-recaptcha siteKey="6LfixyUaAAAAAAOTNgrwQpbprMhW5JOqZhOh4IFm"
                          :show="show"
                          size="normal"
                          theme="light"
                          :tabindex="0"
                          @verify="recaptchaVerified"
                          @expire="recaptchaExpired"
                          @fail="recaptchaFailed"
                          ref="vueRecaptcha"/>
          </div>
          <ui-alert v-show="error" class="mt-4">
            <p class="text-sm text-yellow-800">
              {{ error }}
            </p>
          </ui-alert>
          <div class="mt-4 flex justify-start">
            <span class="ml-2 block text-sm leading-5 text-gray-900">
              Нажимая  «Продолжить регистрацию», вы принимаете условия <a target="_blank" href="#" class="link">пользовательского соглашения</a>
            </span>
          </div>

          <div class="mt-4">
            <ui-button type="submit" class="block w-full" :disabled="!formValid">Продолжить регистрацию</ui-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>

import UiButton from "@/components/ui/button/UiButton";
import UiFormItem from "@/components/ui/form/UiFormItem";
import UiFormText from "@/components/ui/form/UiFormText";
import UiFormPassword from "@/components/ui/form/UiFormPassword";
import {mapActions} from "vuex";
import UiAlert from "@/components/ui/alert/UiAlert";
import UiRecaptcha from "@/components/ui/UiRecaptcha";

export default {
  name: "Create",
  components: {UiRecaptcha, UiAlert, UiFormPassword, UiFormText, UiFormItem, UiButton},
  data() {
    return {
      form: {
        email: '',
        password: '',
        captcha: ''
      },
      error: '',
      show: true
    }
  },
  methods: {
    ...mapActions('account', ['store']),
    recaptchaVerified(response) {
      this.form.captcha = response;
      this.error = '';
    },
    recaptchaExpired() {
      this.$refs.vueRecaptcha.reset();
    },
    recaptchaFailed() {
    },
    tryReg() {
      this.error = ''
      if (this.form.captcha === '') {
        this.error = 'Подтвердите, что вы не робот'
      } else {
        this.store(this.form).then(() => {
          this.form = {email: '', password: '',}
          this.$router.push({name: 'Home'})
        }).catch(errors => {
          this.error = errors._all.join(' ');
        })
      }


      /* this.$http.post('auth/registration', this.form)
           .then(response => {
             if (response.status === 200 && response.data.accessToken) {
               localStorage.setItem('user', JSON.stringify(response.data.user));
               localStorage.setItem('accessToken', response.data.accessToken);
               window.location.reload(true);
             }
           }).catch(error => {
         if (error.response.status === 422) {
           this.error = error.response.data.error
         }
       })*/

    }
  },
  computed: {
    formValid() {
      return this.form.email !== '' && this.form.password !== '';
    }
  }

}
</script>

<style scoped>

</style>